import styled from "styled-components";
import { pxToRem } from "styles/utils";
import { Input as SharedInput } from "../../IOSCompatibleInput/IOSCompatibleInput.style";
import {
  ModalBodyBase,
  ModalCloseButtonBase,
  ModalDividerBase,
  ModalFooterBase,
  ModalHeaderBase,
  ModalOverlayBase,
  ModalSurfaceBase,
} from "../ModalPrimitives";

export const ModalOverlay = styled(ModalOverlayBase)``;

export const ModalContent = styled(ModalSurfaceBase)`
  width: min(60vw, ${pxToRem(720)});
  min-width: ${pxToRem(500)};

  @media (max-width: 700px) {
    width: 100%;
    min-width: 0;
  }
`;

export const ModalHeader = styled(ModalHeaderBase)``;
export const Divider = styled(ModalDividerBase)``;
export const CloseButton = styled(ModalCloseButtonBase)``;

export const ModalBody = styled(ModalBodyBase)`
  padding-bottom: 0;
`;

export const ModalFooter = styled(ModalFooterBase)`
  justify-content: center;
  padding-top: 0;
`;

export const FieldWrapper = styled.div`
  margin-bottom: ${({ theme }) => pxToRem(theme.spacing.xl)};
`;

export const Input = styled(SharedInput)``;

export const ErrorMessage = styled.div`
  margin-top: ${({ theme }) => pxToRem(-theme.spacing.xs)};
  margin-bottom: ${({ theme }) => pxToRem(theme.spacing.xxs)};
  color: ${({ theme }) => theme.colors.danger};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.xs)};
  line-height: 1.35;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
